import { Link } from 'react-router-dom'

export const NotFound = (): JSX.Element => {
  return (
    <div>
      This page does not exist. <Link to="/">Back to dashboard</Link>
    </div>
  )
}
